import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';

export class ActivateIosScrollAct extends SyncUIActDecorator {
    public execute(): void {
        this.emitter.emit('UI.IOSScroll.Activate');
        this.onExecuted?.();
    }

    getName(): string {
        return 'ActivateIosScrollAct';
    }
}